import { Component, type ReactNode } from 'react'
import { ModuleDisabledPage } from './ModuleDisabledPage'
import { ApiError } from '@/types'

interface Props { children: ReactNode }
interface State { moduleBlocked: boolean; message?: string }

/**
 * Catches 403 MODULE_NOT_ENABLED errors thrown by React Query queries.
 * Renders a friendly "module not available" screen instead of crashing.
 */
export class ModuleErrorBoundary extends Component<Props, State> {
  state: State = { moduleBlocked: false }

  static getDerivedStateFromError(error: unknown): State | null {
    if (error instanceof ApiError && error.code === 'MODULE_NOT_ENABLED') {
      return { moduleBlocked: true, message: error.message }
    }
    return null
  }

  render() {
    if (this.state.moduleBlocked) {
      return <ModuleDisabledPage message={this.state.message} />
    }
    return this.props.children
  }
}
